module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "datatable-collection"
  }, [(_vm.groupable) ? _c('table', {
    class: {
      'table-striped': _vm.striped
    }
  }, _vm._l((_vm.groups), function(data, group, index) {
    return _c('tr', [_c('td', {
      staticClass: "datatable-group",
      attrs: {
        "colspan": _vm.columnSpan
      }
    }, [_c('div', {
      staticClass: "datatable-group-header",
      attrs: {
        "layout": "row center-justify"
      }
    }, [_c('div', {
      attrs: {
        "self": "size-x1"
      }
    }, [_c('span', {
      staticClass: "datatable-group-label",
      style: (_vm.indentStyle)
    }, [_vm._v(_vm._s(_vm.groupingColumn.formatData(group)))])]), _vm._v(" "), (data.length > 1) ? _c('span', {
      staticClass: "label label-primary datatable-row-count"
    }, [_vm._v(_vm._s(data.length))]) : _vm._e()]), _vm._v(" "), _c('datatable-collection', {
      attrs: {
        "rows": data,
        "columns": _vm.columns,
        "striped": _vm.striped,
        "editable": _vm.editable,
        "line-numbers": _vm.lineNumbers,
        "aggregated": _vm.aggregated,
        "margin": _vm.margin,
        "grouping-columns": _vm.groupingColumns,
        "grouping-index": _vm.groupingIndex + 1,
        "collection-index": _vm.collectionIndex * index,
        "optimize": _vm.optimize,
        "message": _vm.message
      }
    })], 1)])
  })) : _c('table', {
    staticClass: "datatable-resultset",
    class: {
      'table-striped': _vm.striped
    }
  }, [(_vm.rows.length < 1) ? _c('tr', [_c('td', {
    staticClass: "datatable-info-cell",
    attrs: {
      "colspan": _vm.columnSpan
    }
  }, [_vm._v(_vm._s(_vm.message))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.rows), function(row, index) {
    return _c('tr', [(_vm.lineNumbers) ? _c('td', {
      staticClass: "datatable-cell datatable-linenumber-cell",
      style: ({
        width: _vm.margin
      })
    }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.collectionIndex + index + 1) + "\n\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.aggregated) ? _c('td', {
      staticClass: "datatable-cell datatable-aggregate-cell",
      style: ({
        width: '100px'
      })
    }, [_vm._v("\n\t\t\t\t \n\t\t\t")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.columns), function(column) {
      return _c('datatable-cell', {
        key: column.id,
        attrs: {
          "column": column,
          "row": row,
          "editable": _vm.editable,
          "optimize": _vm.optimize
        }
      })
    })], 2)
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d5a1252a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Datatable/datatable-collection.vue
// module id = 2191
// module chunks = 0